import { useMutation } from '@vue/apollo-composable'
import AddCustomersSpecialPriceMutation from '../graphql/AddCustomersSpecialPriceMutation.graphql'

export const useAddCustomerSpecialPrice = () => {
	const {
		mutate: addCustomerSpecialPrice,
		loading,
		error,
		onDone,
		onError,
	} = useMutation(AddCustomersSpecialPriceMutation)

	const addPrice = async ({
		company_id,
		customer_id,
		stock_id,
		customers_price,
	}) => {
		try {
			const result = await addCustomerSpecialPrice({
				company_id,
				customer_id,
				stock_id,
				customers_price: parseInt(customers_price),
			})

			if (result && result.data && result.data.insert_customer_price_list) {
				return result.data.insert_customer_price_list.returning[0]
			}
			return null
		} catch (err) {
			console.error('Error adding customer special price:', err)
			throw err
		}
	}

	return {
		addPrice,
		loading,
		error,
		onDone,
		onError,
	}
}

// Alternative implementation as a standalone function
export const addCustomerSpecialPrice = async (
	apolloClient,
	{ company_id, customer_id, stock_id, customers_price },
) => {
	try {
		const { data } = await apolloClient.mutate({
			mutation: AddCustomersSpecialPriceMutation,
			variables: {
				company_id,
				customer_id,
				stock_id,
				customers_price: parseInt(customers_price),
			},
		})

		if (data && data.insert_customer_price_list) {
			return data.insert_customer_price_list.returning[0]
		}
		return null
	} catch (error) {
		console.error('Error adding customer special price:', error)
		throw error
	}
}
